<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->

<div *ngIf="loading">
  <div class="loader smaller-loader"></div>
</div>
